if (!customElements.get('localization-form')) {
    customElements.define(
        'localization-form',
        class LocalizationForm extends HTMLElement {
            connectedCallback() {
                this.form = this.querySelector('form');
                this.select = this.querySelector('select');
                this.input = this.querySelector(
                    'input[name="country_code"], input[name="locale_code"]'
                );

                if (this.select) {
                    this.select.addEventListener('change', this.onChange.bind(this));
                }
            }

            onChange(event) {
                const option = event.target.selectedOptions[0];
                if (!option || !this.input) return;

                this.input.value = option.dataset.value;
                if (this.form) this.form.submit();
            }
        }
    );
}